module.exports = __webpack_public_path__ + "img/icon-tag-defaul-ic-tagcode-quickvod@3x.7e915bb3.png";